import Vue from 'vue'

// 创建全局Vue对象作为事件总线
// 使用方法：
// 发射事件：
// bus.$emit('setNickName', '张三');
// 监听事件：可放在组件created方法中
// bus.$on('setNickName', (text) => {
//   this.nickname = text;
// })
export const bus = new Vue()